import { on, select, ready, getData } from 'helpers/dom'

const selectors = {
  CAROUSEL_CLASS: '.js-product-box-content carousel-main',
  CAROUSEL_TITLE_CLASS: '.js-carousel-title'
}

class ProductContain extends HTMLElement {
  constructor () {
    super()

    this.carouselEl = select(selectors.CAROUSEL_CLASS, this)
    this.carouselTitleEl = select(selectors.CAROUSEL_TITLE_CLASS, this)

    this.slidesPerView = 0
  }

  connectedCallback() {
    ready(() => {
      setTimeout(() => {
        this.slidesPerView = this.carouselEl.slidesPerView
        this.setCarouselTitle(0)
        this.getActiveIndex()
      }, 100)
    })
  }

  setCarouselTitle (index) {
    const dataTitle = getData('title', this.carouselTitleEl)
    const dataBox = getData('box', this.carouselTitleEl)
    const slidesPerView = this.slidesPerView + index > dataBox ? dataBox : this.slidesPerView + index
    this.carouselTitleEl.innerHTML = `${dataTitle} (${slidesPerView} of ${dataBox})`
  }

  getActiveIndex() {
    on('change-index', (value) => {
      this.setCarouselTitle(value.detail)
    }, this.carouselEl)
  }
}

customElements.define('product-contain', ProductContain)
